import { configureStore } from "@reduxjs/toolkit";
import {ThemeSlice} from "./Theme/ThemeSlice";
import {DataSlice} from "./Data/DataSlice";
import { MenuSlice } from "./Menu/MenuSlice";


export const dashboardStore = configureStore({
    reducer : {
        theme: ThemeSlice.reducer,
        data: DataSlice.reducer,
        menu: MenuSlice.reducer
    }
})

export type RootState = ReturnType<typeof dashboardStore.getState>
export type AppDispatch = typeof dashboardStore.dispatch